/**
 * The choose screen's own string, verbatim from the agreed copy. The heading, group titles and
 * buttons are the shared EntityTypeSelector's, and the tiles carry their own copy.
 */

export const CHOOSE_ENTITY_INTRO =
  'Please select the type of entity you want to verify. If you do not have any entity types that applies to you, select ‘Individual’ to get started.';
